import React from 'react';
import PropTypes from 'prop-types';

class Pager extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      onPrevious,
      onNext,
      onFinish,
      total,
      current,
    } = this.props;
    return (
      <ul className={"pager " + this.props.className}>
        <li onClick={current > 1 ? onPrevious : f => {/* do nothing */}} className={`previous${ current == 1 ? ' disabled' : ''}`}><a><i className="fa fa-angle-left"></i> Previous</a></li>
        <li onClick={current == total ? this.props.onFinish : f => {}} className={`finish${total != current ? ' hidden' : ''} pull-right`}><a>Finish</a></li>
        <li onClick={current < total ? this.props.onNext : f => {}} className={`next${total == current ? ' hidden' : ''}`}><a><i className="fa fa-angle-right"></i> Next</a></li>
      </ul>

    )
  }
}

Pager.propTypes = {
  onPrevious : PropTypes.func.isRequired,
  onNext : PropTypes.func.isRequired,
  onFinish : PropTypes.func.isRequired,
  total : PropTypes.number.isRequired,
  current : PropTypes.number.isRequired,
}

export default Pager;



// WEBPACK FOOTER //
// ./src/browser/components/ui/pager.js